import { useEffect, useState } from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import QRCodeModal from "../../QRCodeModal/QRCodeModal";
import {
  showAlert,
  showLoading,
  apiRequest,
  PLAYER_URL_PREFIX,
} from "../../../utils";
import { Confirm } from "../../../components/confirm/confirm";

import ss from "./GameProcess.module.css";

export const GameProcess = () => {
  const session_uuid = useSelector((state) => state.gameSession.session_uuid);
  const sessionStatus = useSelector((state) => state.gameSession.status);
  const [sessionData, setSessionData] = useState({});
  const [currentTime, setCurrentTime] = useState(sessionData.start_time || -1);
  const [isPaused, setIsPaused] = useState(false);

  const getSessionInfo = () => {
    // const loading = showLoading("加载中");
    apiRequest("/get_session_info", "GET", { session_uuid })
      .then((res) => {
        setSessionData(res.game_session);
        setIsPaused(res.game_session.status === 120);
      })
      .catch((err) => showAlert("请求失败，请稍后重试", err.message));
    // .finally(() => loading.hide());
  };

  // 获取场次信息
  useEffect(() => {
    getSessionInfo();
  }, [session_uuid, sessionStatus]);

  useEffect(() => {
    if (sessionData.start_time >= 0) setCurrentTime(sessionData.start_time);
    if (sessionData.status !== 100) return;
    const timer = setInterval(() => {
      if (currentTime === sessionData.duration * 60) {
        getSessionInfo();
        return;
      }
      setCurrentTime((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [sessionData.start_time, sessionData.status]);

  if (!sessionData) return null;

  return (
    <>
      <div className={ss.container}>
        <div className={ss.title}>游戏流程</div>
        <div className={ss.baseContainer}>
          <div className={ss.baseItem}>
            <div className={ss.baseItemTitle}>游戏时长</div>
            <div className={ss.baseItemValue}>{sessionData.duration}分钟</div>
          </div>
          <div className={ss.baseItem}>
            <div className={ss.baseItemTitle}>地图</div>
            <div className={ss.baseItemValue}>{sessionData.map_name}</div>
          </div>
          <div className={ss.baseItem}>
            <div className={ss.baseItemTitle}>队伍</div>
            <div className={ss.baseItemValue}>{sessionData.team_count}</div>
          </div>
          <div className={ss.baseItem}>
            <div className={ss.baseItemTitle}>总人数</div>
            <div className={ss.baseItemValue}>{sessionData.player_count}人</div>
          </div>
        </div>
        <div className={ss.rowContainer}>
          <div className={ss.time}>
            时间：
            <span>
              {(() => {
                if (sessionData.status >= 200) return "已结束";
                if (sessionData.status < 100) return "--:--";
                const minutes = Math.floor(currentTime / 60);
                const seconds = currentTime % 60;

                return `${minutes.toString().padStart(2, "0")}:${seconds
                  .toString()
                  .padStart(2, "0")}`;
              })()}
            </span>
          </div>
          <div
            className={classNames(
              ss.btn,
              (isPaused || sessionData.status !== 100) && ss.disabled
            )}
            onClick={() => {
              const loading = showLoading("加载中");
              apiRequest("/pause_game_session", "POST", { session_uuid })
                .then((res) => {
                  if (res.code === 0) {
                    setIsPaused(true);
                    getSessionInfo();
                  } else {
                    showAlert(res.msg);
                  }
                })
                .catch((err) => showAlert("请求失败，请稍后重试", err.message))
                .finally(() => loading.hide());
            }}
          >
            暂停
          </div>
          <div
            className={classNames(
              ss.btn,
              (!isPaused || sessionData.status !== 120) && ss.disabled
            )}
            onClick={() => {
              const loading = showLoading("加载中");
              apiRequest("/resume_game_session", "POST", { session_uuid })
                .then((res) => {
                  if (res.code === 0) {
                    // showAlert("游戏已继续");
                    setIsPaused(false);
                    getSessionInfo();
                  } else {
                    showAlert(res.msg);
                  }
                })
                .catch((err) => showAlert("请求失败，请稍后重试", err.message))
                .finally(() => loading.hide());
            }}
          >
            继续
          </div>
        </div>
        <div className={ss.rowContainer}>
          <div
            className={ss.btn}
            onClick={() => {
              QRCodeModal.show({
                type: "login",
                url: `${PLAYER_URL_PREFIX}/login?sid=${session_uuid}`,
                onClose: () => {
                  QRCodeModal.hide();
                },
              });
            }}
          >
            登录二维码
          </div>
          <div
            className={ss.btn}
            onClick={() => {
              Confirm.show("请确认是否揭晓冠军", () => {
                const loading = showLoading("加载中");
                apiRequest("/show_team_rank", "POST", { sid: session_uuid })
                  .then((res) => {
                    if (res.code === 0) showAlert("冠军已揭晓");
                    else showAlert(res.msg);
                  })
                  .catch((err) =>
                    showAlert("请求失败，请稍后重试", err.message)
                  )
                  .finally(() => {
                    loading.hide();
                  });
              });
            }}
          >
            揭晓冠军
          </div>
          <div
            className={ss.btn}
            onClick={() => {
              Confirm.show("请确认是否提前结束", () => {
                const loading = showLoading("加载中");
                apiRequest("/end_game_session", "POST", { session_uuid })
                  .then((res) => {
                    if (res.code === 0) {
                      apiRequest("/get_session_info", "GET", { session_uuid })
                        .then((res) => {
                          setSessionData(res.game_session);
                        })
                        .catch((err) =>
                          showAlert("请求失败，请稍后重试", err.message)
                        );
                      // .finally(() => loading.hide());
                      showAlert("游戏结束成功");
                    } else {
                      showAlert(res.msg);
                    }
                  })
                  .catch((err) => console.log(err))
                  .finally(() => loading.hide());
              });
            }}
          >
            提前结束
          </div>
        </div>
      </div>
    </>
  );
};
